<template>
	<div class="notif-wrapper">
		<v-menu
			bottom
			offset-y
			left
			:min-width="$vuetify.breakpoint.smAndDown ? '95vw' : '500'"
			:max-width="$vuetify.breakpoint.smAndDown ? '95vw' : '500'"
			content-class="container-notification-menu-header"
			@input="changeMenu"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-badge
					class="notif-badge"
					:color="$store.notificationsStore.state.badgeColor"
					:content="$store.notificationsStore.state.badgeText"
					overlap
				>
					<v-btn
						icon
						:small="size === 'small'"
						:x-small="size === 'x-small'"
						:loading="$store.notificationsStore.state.loadingNotifications"
						class="notif-bell-btn"
						:ripple="false"
						v-bind="attrs"
						v-on="on"
					>
						<v-icon color="white" :small="size === 'small'" :x-small="size === 'x-small'">mdi-bell-outline</v-icon>
					</v-btn>
				</v-badge>
			</template>

			<!-- Header -->
			<div class="notif-header">
				<div class="notif-header-left">
					<div class="notif-dot"></div>
					<span class="notif-title">Notificaciones</span>
				</div>
				<v-btn icon small color="grey" @click.stop="reloadNotifications">
					<v-icon size="18">mdi-cached</v-icon>
				</v-btn>
			</div>

			<!-- Tabs -->
			<div class="notif-tabs">
				<div
					class="notif-tab-container"
					v-for="tab in tabs"
					:key="tab.value"
				>
					<button
						class="notif-tab"
						style="min-width: 80px;"
						:class="{ active: activeTab === tab.value }"
						@click.stop="activeTab = tab.value"
					>
						{{ tab.label }}
					</button>
					<div class="notif-tab-count" v-if="getNotificationCountByType(tab.value) > 0">
						{{ getNotificationCountByType(tab.value) > 0 ? `${getNotificationCountByType(tab.value)}` : '' }}
					</div>
				</div>
			</div>

			<v-divider></v-divider>

			<!-- Lista de notificaciones -->
			<v-list v-if="filteredNotifications.length > 0" class="notif-list py-0">
				<v-list-item
					v-for="(item, i) in filteredNotifications"
					:key="i"
					class="notif-item px-0 py-0"
					@click="viewItem(item.item_id, item.item_type, item.action)"
				>
					<div class="notif-item-inner">
						<!-- Avatar -->
						<div class="notif-avatar">
							<img
								v-if="item.image && item.image !== ''"
								:src="item.image"
								class="notif-avatar-img"
							/>
							<v-icon v-else size="18" color="#2D4B95">mdi-account</v-icon>
						</div>

						<!-- Contenido -->
						<div class="notif-body">
							<div class="d-flex align-center justify-space-between">
								<span class="notif-project mb-0">{{ item.project_name }}</span>
								<div class="d-flex align-center" style="gap: 5px;">
									<v-icon size="12" color="#AAAAAA">mdi-clock-outline</v-icon>
									<span class="notif-time mb-0">{{ getNotificationDate(item) | toDateTime }}</span>
								</div>
							</div>
							<p class="notif-name mb-0">{{ item.title }}</p>
							<div
								class="notif-desc"
								v-html="item.description"
							></div>
						</div>
						<!-- Botón marcar como leída -->
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<button
									class="mark-read-btn"
									:class="{ done: loadingIndexes.includes(i) }"
									v-bind="attrs"
									v-on="on"
									@click.stop="markNotificationAsRead(item.id, i)"
								>
									<v-icon size="18" :color="loadingIndexes.includes(i) ? '#1D9E75' : '#AAAAAA'">
										mdi-message-check-outline
									</v-icon>
								</button>
							</template>
							<span>Marcar como leída</span>
						</v-tooltip>
					</div>
					<v-divider class="mx-3"></v-divider>
				</v-list-item>
			</v-list>

			<!-- Estado vacío -->
			<div v-else class="notif-empty">
				<v-icon size="32" color="grey lighten-1">mdi-bell-check-outline</v-icon>
				<p class="notif-empty-text mb-0">No hay notificaciones nuevas</p>
			</div>
		</v-menu>
	</div>
</template>

<script>
import {getTareaByID, markTaskAsRead} from '@/helpers/api/tasks'
import {getRdiByID, markRdiAsRead} from '@/helpers/api/rdi'
import { getEntregaByID, getConfig } from "@/helpers/api/entrega";
import { getDraftByID } from '@/helpers/api/drafts'
import { getFolio } from '@/helpers/api/communicationBooks'
import { getJobTypes } from "@/helpers/api/user";

import {markNotificationAsReaded} from '@/helpers/api/general'

export default {
	name: 'NotificationHeader',
	props: {
		size: {
			type: String,
			default: 'large'
		}
	},
	components: {},
	computed: {
		loadingNotifications() {
			return this.$store.notificationsStore.state.loadingNotifications
		},
		notifications() {
			return this.$store.notificationsStore.state.notifications || []
		},
		filteredNotifications() {
			const all = this.$store.notificationsStore.state.notifications
			if (this.activeTab === 0) return all
			return all.filter(n => n.item_type === this.activeTab)
		},
		selectedProject() {
			return this.$store.projectsStore.state.selectedProject
		}
	},
	watch: {
		loadingNotifications(newData) {
			if (newData) {
				this.reloading = true
			} else if (this.reloading) {
				this.reloading = false
				this.loadingIndexes = []
				this.loadingTaskIndexes = []
				this.loadingRdiIndexes = []
			}
		}
	},
	data: () => ({
		reloading: false,
		loadingIndexes: [],
		loadingTaskIndexes: [],
		loadingRdiIndexes: [],
		menuOpen: false,
		activeTab: 0,
		tabs: [
			{ label: 'Todas', value: 0 },
			{ label: 'Tareas', value: 1 },
			{ label: 'RDI', value: 2 },
			{ label: 'Adicionales', value: 3 },
			{ label: 'Entregas', value: 5 },
			{ label: 'Folios', value: 7 },
		]
	}),
	methods: {
		getNotificationCountByType(type) {
			if(!this.notifications) return 0
			if(type === 0) return this.notifications?.length
			return this.notifications?.filter(n => n.item_type === type).length || 0
		},
		getNotificationDate(notification) {
			return notification.updated_at || notification.created_at
		},
		reloadNotifications() {
			this.$store.notificationsStore.dispatch('getNotifications', {
				project_id: this.$store.projectsStore.state.selectedProject.id
			})
		},
		async viewTarea(task_id) {
			this.$store.consultasStore.commit('setCurrentTarea', { loading: true })
			const tarea = await getTareaByID({ task_id })
			if (tarea.code === 200) {
				this.reloadNotifications()
				let tareaData = tarea.task
				tareaData.prev_seen_by_me = false
				this.$store.consultasStore.commit('setCurrentTarea', tareaData)
			}
		},
		async viewRDI(rdi_id) {
			this.$store.rdiStore.commit('setCurrentRDI', { loading: true })
			const rdi = await getRdiByID({ rdi_id })
			if (rdi.code === 200) {
				this.reloadNotifications()
				let rdiData = rdi.rdi
				rdiData.prev_seen_by_me = false
				this.$store.rdiStore.commit('setCurrentRDI', rdiData)
			}
		},
		viewAdditional(additional_id) {
			this.$store.adicionalesStore.commit('setCurrentAdicional', { loading: true })
			this.$store.adicionalesStore.dispatch('getAdditionalByID', {
				additional_id,
				seen_by_me: false
			})
		},

    async viewEntrega(entregaId) {
      if (!this.selectedProject) return;
      const projectID = this.selectedProject.id;
      this.$store.entregaStore.commit("setCurrentEntrega", { loading: true });
      try {
        const entregaResponse = await getEntregaByID({ entrega_id: entregaId });
        const [configResponse, jobTypesResponse] = await Promise.all([
          getConfig({ project_id: projectID }),
          getJobTypes({ project_id: projectID }),
        ]);
        this.$store.usersStore.commit("setJobTypes", jobTypesResponse.job_types);
        this.$store.entregaStore.commit("setConfig", configResponse.config);
				if (entregaResponse.code === 403) {
					this.$store.entregaStore.commit("setCurrentEntrega", null);
				} else if (entregaResponse.code === 200) {
          const entregaData = entregaResponse.entrega;
          entregaData.prev_seen_by_me = false;
          this.$store.entregaStore.commit("setCurrentEntrega", entregaData);
        }
      } catch (error) {
        this.$store.entregaStore.commit("setCurrentEntrega", { loading: false, error: true });
      }
    },
		async viewFolio(folioId) {
			const response = await getFolio(folioId)
			if (response && Number(response.code) === 403) {
				this.$store.communicationBooksStore.commit('setAccessDenied', true)
				return
			}
			this.$store.communicationBooksStore.commit('setCurrentFolio', response)
			this.$router.push({ name: 'CommunicationBooks', query: { folio_id: folioId } })
		},
    async viewDraft(draft_id) {
      const draftData = await getDraftByID({ id: draft_id })
      if (draftData.code === 200) {
        this.parseData(draftData.draft)
        this.loadDraft(draftData.draft)
      }
    },
    parseData(draft) {
      if (draft.data && typeof draft.data === 'string') {
        try { draft.data = JSON.parse(draft.data) } catch (e) { draft.data = {} }
      }
      return draft
    },
		loadDraft(draft){
			const draftType = draft.raw_type
			
			if(draftType === 1) {
				this.$store.consultasStore.commit('setDraftToLoad', draft)
				this.$store.consultasStore.commit('setCreateTareaModal', true)
			}
			else if(draftType === 2) {
				this.$store.rdiStore.commit('setDraftToLoad', draft)
				this.$store.rdiStore.commit('setCreateRDIModal', true)
			}
			else if(draftType === 3) {
				this.$store.adicionalesStore.commit('setDraftToLoad', draft)
				this.$store.adicionalesStore.commit('setCreateAdicionalModal', true)
			}
			else if(draftType === 4) {
				this.$store.adicionalesStore.commit('setDraftToLoad', draft)
				this.$store.adicionalesStore.commit('setCreatePosibleAdicionalModal', true)
			}
			else if(draftType === 5) {
				this.$store.entregaStore.commit('setDraftToLoad', draft)
				this.$store.entregaStore.commit('setCreateEntregaModal', true)
			}
		},
		async markAsRead(item_id, type, index) {
			if (type == 1) {
				this.loadingTaskIndexes.push(index)
				const tasks = await markTaskAsRead({ task_id: item_id })
				if (tasks.code == 200) this.reloadNotifications()
			} else if (type == 2) {
				this.loadingRdiIndexes.push(index)
				const tasks = await markRdiAsRead({ rdi_id: item_id })
				if (tasks.code == 200) this.reloadNotifications()
			}
		},
		async viewItem(item_id, type, action = null) {
			if (type == 1) this.viewTarea(item_id)
			else if (type == 2) this.viewRDI(item_id)
			else if (type == 3){
				if(action && action == 2){
					this.$router.push({name: 'Adicionales', query: {listing_type: 3}})
					return
				}
				this.viewAdditional(item_id)
			}
			else if(type == 4){
				this.viewDraft(item_id)
				return
			}
			else if(type == 5){
				if(action && action == 5){
					this.viewEntrega(item_id)
					return
				}
			}
			else if(type == 7) this.viewFolio(item_id)
		},
		async markNotificationAsRead(notification_id, index) {
			this.loadingIndexes.push(index)
			const tasks = await markNotificationAsReaded({ id: notification_id })
			if (tasks.code == 200) this.reloadNotifications()
		},
		changeMenu(value) {
			this.menuOpen = value
		}
	}
}
</script>

<style scoped>
/* Menú contenedor */
.container-notification-menu-header {
	background: white;
	margin-top: 10px;
	border-radius: 12px;
	border: 1px solid #EAECF4;
	box-shadow: 0 4px 20px rgba(45, 75, 149, 0.10);
	max-width: calc(100vw - 16px) !important;
	overflow: hidden;
}

/* Wrapper */
.notif-wrapper {
	position: relative;
	display: inline-flex;
	align-items: center;
}

/* Botón campana */
.notif-bell-btn {
	background: linear-gradient(135deg, #5E85EF 0%, #2D4B95 100%) !important;
	border-radius: 8px !important;
}
.notif-bell-btn::before {
	display: none !important;
}
/deep/ .notif-bell-btn::before {
	display: none !important;
}
/deep/ .notif-bell-btn.v-btn:focus::before,
/deep/ .notif-bell-btn.v-btn:active::before,
/deep/ .notif-bell-btn.v-btn:hover::before {
	opacity: 0 !important;
}

/deep/ .notif-badge .v-badge__badge {
	top: -5px !important;
	right: 2px !important;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}

/* Header */
.notif-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 16px 4px;
}
.notif-header-left {
	display: flex;
	align-items: center;
	gap: 8px;
}
.notif-dot {
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: #2D4B95;
	flex-shrink: 0;
}
.notif-title {
	font-size: 14px;
	font-weight: 600;
	color: #2D4B95;
}
.notif-time {
	font-size: 10px;
	color: #AAAAAA;
	white-space: nowrap;
}

/* Tabs */
.notif-tabs {
	display: flex;
	padding: 0 12px;
	gap: 0;
	border-bottom: 1px solid #EEEEEE;
}
.notif-tab {
	font-size: 12px;
	padding: 6px 10px;
	background: none;
	border: none;
	border-bottom: 2px solid transparent;
	color: #999999;
	cursor: pointer;
	transition: color 0.15s, border-color 0.15s;
	font-family: inherit;
	white-space: nowrap;
}
.notif-tab.active {
	color: #2D4B95;
	border-bottom-color: #2D4B95;
	font-weight: 600;
}

/* Lista */
.notif-list {
	max-height: 400px;
	overflow-y: auto;
}

/* Item */
.notif-item {
	cursor: pointer;
	transition: background 0.12s;
}
.notif-item:hover {
	background-color: #F5F7FF;
}
.notif-item-inner {
	display: flex;
	align-items: flex-start;
	gap: 12px;
	padding: 12px 16px;
	width: 100%;
}

/* Avatar */
.notif-avatar {
	width: 38px;
	height: 38px;
	border-radius: 50%;
	background-color: #EEF1FB;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}
.notif-avatar-img {
	width: 38px;
	height: 38px;
	border-radius: 50%;
	object-fit: cover;
}

/* Cuerpo */
.notif-body {
	flex: 1;
	min-width: 0;
}
.notif-project {
	font-size: 11px;
	color: #AAAAAA;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.notif-name {
	font-size: 13px;
	font-weight: 600;
	color: #444444;
}
.notif-desc {
	font-size: 12px;
	color: #888888;
	line-height: 1.5;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}

/* Botón marcar como leída */
.mark-read-btn {
	flex-shrink: 0;
	width: 30px;
	height: 30px;
	border-radius: 6px;
	border: 1px solid #EEEEEE;
	background: transparent;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 2px;
	transition: background 0.12s, border-color 0.12s;
}
.mark-read-btn:hover {
	background-color: #F0FBF7;
	border-color: #1D9E75;
}
.mark-read-btn.done {
	background-color: #F0FBF7;
	border-color: #1D9E75;
}

/* Estado vacío */
.notif-empty {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 36px 16px;
	gap: 10px;
}
.notif-empty-text {
	font-size: 13px;
	color: #AAAAAA;
}

.notif-tab-container {
	position: relative;
	display: flex;
	align-items: center;
}
.notif-tab-count {
	position: absolute;
	top: -4px;
	right: 0px;
	background-color: #2D4B95;
	color: white;
	font-size: 10px;
	font-weight: 600;
	padding: 2px 6px;
	border-radius: 12px;
	min-width: 20px;
	text-align: center;
	line-height: 1;
}

/deep/ .notif-desc p { margin: 0; }
</style>